import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  getAllGroupUsersAction,
  getAllGroupUsersActionByNumber,
  getAllGroupUsersActionBySearch,
  getNonGroupUsersAction,
  getNonGroupUsersByNumberAction,
  getNonGroupUsersBySearchAction,
} from '../../../../redux/actions/chatActions';
import { useDispatch, useSelector } from 'react-redux';

const useGroupInfoModalFunctions = ({ setShowModal, setShowSelectedUser, groupId, socket, getAcceptedUsers, groupName, setGroupName }) => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [leaveConfirmModal, setLeaveConfirmModal] = useState(false);
  const [circularLoader, setCircularLoader] = useState(false);
  const [adminControl, setAdminControl] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [loading, setLoading] = useState(true);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [nameEdit, setNameEdit] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [addUser, setAddUser] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [groupMembers, setGroupMembers] = useState([]);
  const [inputGrouNameValue, setInputGrouNameValue] = useState(groupName);
  const [searchResults, setSearchResults] = useState([]);
  const [addUserSearchResults, setAddUserSearchResults] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [hasMoreNonGroupData, setHasMoreNonGroupData] = useState(true);
  const [isSearching, setIsSearching] = useState(false);
  const [isAddUserSearching, setIsAddUserSearching] = useState(false);
  const [page, setPage] = useState(2);
  const [nonGroupUserspage, setNonGroupUserspage] = useState(2);
  const userLogin = useSelector(state => state.userLogin);
  const onlineUsers = useSelector(state => state.onlineUsers);

  const adminId = useMemo(() => {
    if (groupMembers) {
      const admin = groupMembers?.filter(item => item?.role === 'admin');
      return admin[0]?.hasOwnProperty('_id') ? admin[0]._id : null;
    }
  }, [groupMembers]);

  useEffect(() => {
    if (adminId && userLogin?.userInfo?.data?.user?._id === adminId) {
      setAdminControl(true);
    }
  }, [adminId, userLogin]);

  useEffect(() => {
    getGroupUsers();
  }, []);

  const getGroupUsers = React.useCallback(async () => {
    try {
      const groupData = await dispatch(getAllGroupUsersActionByNumber(groupId, 1));
      const members = groupData?.data ?? [];
      setGroupMembers(members);
      setSearchResults(members);
      if (members && members.length > 0) setLoading(false);
    } catch (error) {
      console.error('Error fetching group data:', error);
    }
  }, [dispatch, groupId]);

  useEffect(() => {
    getNotAvailableUsers();
  }, [addUser]);

  const getNotAvailableUsers = React.useCallback(async () => {
    try {
      const data = await dispatch(getNonGroupUsersByNumberAction(groupId, 1));
      setAddUserSearchResults(data?.data);
    } catch (error) {
      console.error('Error fetching group data:', error);
    }
  }, [dispatch, groupId]);

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      const userData = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userLogin.userInfo.data.user._id);
      const orgId = userLogin.userInfo.data.user.org;
      socket.emit('sendMultipleRequest', {
        members: selectedItems,
        groupId: groupId,
        mySocketId: userData.socketId,
        // senderId: userData.senderId,
        orgId: orgId,
      });

      setLoading(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    },
    [selectedItems],
  );

  const handleRemoveUser = useCallback(() => {
    const userData = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userLogin.userInfo.data.user._id);
    const orgId = userLogin.userInfo.data.user.org;
    const formData = {
      groupId: groupId,
      userId: selectedUserId,
      orgId: orgId,
      mySocketId: userData.socketId,
    };
    const updatedMember = searchResults.filter(item => item._id !== selectedUserId);
    setTimeout(() => setSearchResults(updatedMember), 1400);
    socket.emit('removedFromGroup', formData);
  }, [groupId, onlineUsers.onlineUsers, selectedUserId, socket, userLogin.userInfo.data.user._id, userLogin.userInfo.data.user.org]);

  const handleLeaveGroup = useCallback(() => {
    const userData = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userLogin.userInfo.data.user._id);
    const orgId = userLogin.userInfo.data.user.org;
    const formData = {
      groupId: groupId,
      userId: userData?.userId,
      orgId: orgId,
      mySocketId: userData.socketId,
    };
    socket.emit('removedFromGroupSelf', formData);
    getAcceptedUsers();
    setShowSelectedUser(false);
    setLeaveConfirmModal(false);
    setShowModal(false);
  }, [getAcceptedUsers, groupId, onlineUsers.onlineUsers, setShowModal, setShowSelectedUser, socket, userLogin.userInfo.data.user._id, userLogin.userInfo.data.user.org]);

  React.useEffect(() => {
    if (socket) {
      socket.on('removedFromGroupSuccess', response => {
        if (response.data.status) {
          setToastMessage('Removing User');
          setShowSuccessToast(true);
          getGroupUsers();
          const updatedMmebers = () => groupMembers.filter(item => item._id !== selectedUserId);
          setGroupMembers(updatedMmebers);
          setSearchQuery('');
          getAcceptedUsers();
        } else {
          setToastMessage('Request failed try again !');
          setShowErrorToast(true);
          getGroupUsers();
        }
      });

      socket.on('removedFromGroupSelfSuccess', response => {
        if (response.data.status) {
          getAcceptedUsers();
          setToastMessage('You have left the group.');
          setShowSuccessToast(true);
          setShowSelectedUser(false);
        } else {
          setToastMessage('Request failed try again !');
          setShowErrorToast(true);
          setShowModal(false);
        }
      });

      socket.on('sendMultipleRequestSuccess', response => {
        if (response.data.status) {
          setToastMessage('Sending Request');
          setShowSuccessToast(true);
        } else {
          setToastMessage('Request failed try again !');
          setShowErrorToast(true);
        }
      });

      socket.on('updateGroupSuccess', response => {
        if (response.data.status) {
          setToastMessage(response.data.message);
          setShowSuccessToast(true);
          getAcceptedUsers();
        } else {
          setToastMessage('Request failed try again !');
          setShowErrorToast(true);
        }
      });
    }
  }, [getAcceptedUsers, getGroupUsers, groupMembers, selectedUserId, setShowModal, socket]);

  const onClose = useCallback(() => {
    setShowModal(false);
    setLoading(false);
    setAddUser(false);
    setAdminControl(false);
    setSelectedItems([]);
    setSearchQuery('');
    setSearchResults([]);
  }, [setShowModal]);

  const search = useCallback(
    async query => {
      setIsSearching(true);
      if (query.length > 0) {
        const filteredData = groupMembers.filter(item => item.name.toLowerCase().includes(query.toLowerCase()) | item.email.toLowerCase().includes(query.toLowerCase()));
        setSearchResults(filteredData);
        //     console.log(filteredData, 'filter')
        setCircularLoader(true);
        const data = await dispatch(getAllGroupUsersActionBySearch(groupId, query));
        setTimeout(() => {
          setCircularLoader(false);
        }, 2000);
        setSearchResults(data.data);
      } else {
        const groupData = await dispatch(getAllGroupUsersActionByNumber(groupId, 1));
        setSearchResults(groupData.data);
        setIsSearching(false);
      }
    },
    [dispatch, groupId],
  );

  const searchNonAavailableUsers = useCallback(
    async query => {
      setIsAddUserSearching(true);
      if (query.length > 0) {
        const data = await dispatch(getNonGroupUsersBySearchAction(groupId, query));
        setAddUserSearchResults(data.data);
      } else {
        const groupData = await dispatch(getNonGroupUsersByNumberAction(groupId, 1));
        setAddUserSearchResults(groupData.data);
        setIsAddUserSearching(false);
      }
    },
    [dispatch, groupId],
  );

  const handleInputChange = useCallback(
    e => {
      setSearchQuery(e.target.value);
      search(e.target.value);
    },
    [search],
  );

  const handleNameChange = useCallback(() => {
    const userData = Object.values(onlineUsers.onlineUsers).find(onlineUser => onlineUser['userId'] === userLogin.userInfo.data.user._id);
    const orgId = userLogin.userInfo.data.user.org;
    setGroupName(inputGrouNameValue);
    setNameEdit(false);

    socket.emit('updateGroup', {
      name: inputGrouNameValue,
      groupId: groupId,
      org: orgId,
      mySocketId: userData.socketId,
    });
  }, [groupId, inputGrouNameValue, onlineUsers.onlineUsers, setGroupName, setShowModal, socket, userLogin.userInfo.data.user._id, userLogin.userInfo.data.user.org]);

  const handleInputChange1 = useCallback(
    e => {
      setSearchQuery1(e.target.value);
      searchNonAavailableUsers(e.target.value);
    },
    [searchNonAavailableUsers],
  );

  const handleCheckboxChange = useCallback(
    item => {
      if (selectedItems.some(selected => selected.id === item.id)) {
        setSelectedItems(selectedItems.filter(selected => selected.id !== item.id));
      } else {
        setSelectedItems([...selectedItems, item]);
      }
    },
    [selectedItems],
  );

  const addPartcipiants = useCallback(() => {
    setAddUser(true);
  }, []);

  const onBack = useCallback(() => {
    setAddUser(false);
    setAddUser(false);
    setLoading(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const fetchData = useCallback(async () => {
    if (!circularLoader && hasMoreData && !isSearching) {
      setCircularLoader(true);
      const data = await dispatch(getAllGroupUsersActionByNumber(groupId, page));
      const newData = await data.data;
      if (newData.length > 0) {
        setSearchResults(prevResults => [...prevResults, ...newData]);
        setPage(prevPage => prevPage + 1);
      } else {
        setHasMoreData(false);
      }

      setCircularLoader(false);
    }
  }, [circularLoader, dispatch, groupId, hasMoreData, isSearching, page]);

  const fetchNonGroupData = useCallback(async () => {
    if (!circularLoader && hasMoreNonGroupData && !isAddUserSearching) {
      setCircularLoader(true);
      const data = await dispatch(getNonGroupUsersByNumberAction(groupId, nonGroupUserspage));
      const newData = await data.data;
      if (newData.length > 0) {
        setAddUserSearchResults(prevResults => [...prevResults, ...newData]);
        setNonGroupUserspage(prevPage => prevPage + 1);
      } else {
        setHasMoreNonGroupData(false);
      }

      setCircularLoader(false);
    }
  }, [circularLoader, dispatch, groupId, hasMoreNonGroupData, isAddUserSearching, nonGroupUserspage]);

  const cardListRef1 = useRef(null);
  const cardListRef2 = useRef(null);

  const handleScroll = useCallback(() => {
    if (cardListRef1.current) {
      const { scrollTop, clientHeight, scrollHeight } = cardListRef1.current;

      if (scrollTop + clientHeight >= scrollHeight - 2 && hasMoreData) {
        fetchData();
      }
    }
  }, [fetchData, hasMoreData]);

  const handleNonGroupScroll = useCallback(() => {
    if (cardListRef2.current) {
      const { scrollTop, clientHeight, scrollHeight } = cardListRef2.current;

      if (scrollTop + clientHeight >= scrollHeight - 2 && addUser && hasMoreNonGroupData) {
        fetchNonGroupData();
      }
    }
  }, [addUser, fetchNonGroupData, hasMoreNonGroupData]);

  useEffect(() => {
    if (cardListRef1.current) {
      cardListRef1.current.addEventListener('scroll', handleScroll);
    }
    if (cardListRef2.current) {
      cardListRef2.current.addEventListener('scroll', handleNonGroupScroll);
    }

    return () => {
      if (cardListRef1.current) {
        cardListRef1.current.removeEventListener('scroll', handleScroll);
      }
      if (cardListRef2.current) {
        cardListRef2.current.removeEventListener('scroll', handleNonGroupScroll);
      }
    };
  }, [handleNonGroupScroll, handleScroll, hasMoreData, hasMoreNonGroupData, loading]);

  return {
    isChecked,
    setIsChecked,
    leaveConfirmModal,
    setLeaveConfirmModal,
    circularLoader,
    adminControl,
    setSelectedUserId,
    loading,
    showSuccessToast,
    setShowSuccessToast,
    showInviteModal,
    setShowInviteModal,
    showErrorToast,
    setShowErrorToast,
    nameEdit,
    setNameEdit,
    toastMessage,
    addUser,
    searchQuery,
    searchQuery1,
    inputGrouNameValue,
    setInputGrouNameValue,
    searchResults,
    setSearchResults,
    addUserSearchResults,
    handleSubmit,
    handleRemoveUser,
    handleLeaveGroup,
    onClose,
    handleInputChange,
    handleNameChange,
    handleInputChange1,
    handleCheckboxChange,
    addPartcipiants,
    onBack,
    cardListRef1,
    cardListRef2,
    selectedItems,
  };
};

export default useGroupInfoModalFunctions;
